import React, { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import defaultuser from "../../assets/images/defaultuser.jpg";
import { PATCH, PATCH_MULTIPART } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import Alert from "@/components/alert/Alert";
import { useAppSelector } from "@/hooks/hook";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import { EditIcon } from "@/constants/utils/svgs";
import ChangesAlert from "@/components/alert/ChangesAlert";
import iconEdit from "../../assets/images/iconEdit.png";
import { FiEdit2 } from "react-icons/fi";
import FormModal from "@/components/modals/FormModal";
import AddBartenderModal from "../Bartender/AddBartenderModal";

interface Props {
  id: string;
  img: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  updateBartenderInfo: (info: formInputs) => void;
  navigateEdit: () => void;
  currentBartender: any;
  rerenderFun: () => void;
  isSuperAdmin?: boolean;
}
type formInputs = {
  id: string;
  first_name: string;
  email: string;
  // password: string;
  last_name: string;
  phone_number: string;
};

const BartenderPersonalInformation: React.FC<Props> = ({
  id,
  img,
  first_name,
  last_name,
  email,
  phone_number,
  updateBartenderInfo,
  navigateEdit,
  currentBartender,
  rerenderFun,
  isSuperAdmin,
}) => {
  const [phoneNumber, setPhoneNumber] = useState<string | null>(
    phone_number ?? ""
  );
  const { refreshToken } = useAppSelector((store) => store.user);
  const [loading, setLoading] = useState<boolean>(false);
  const [changed, setChanged] = useState<boolean>(false);
  const [profile, setProfile] = useState<File | null>(null);
  const { bartenders, bartenderAvatar } = API_ROUTES;
  const dispatch = useDispatch();
  const { isChanged } = useAppSelector((store) => store.form);
  const [modal, setModal] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const {
    handleSubmit,
    reset,
    formState: { errors, isDirty },
  } = useForm<formInputs>();
  const onSubmit: SubmitHandler<formInputs> = async (data) => {
    if (changed || isDirty) {
      // if there was a change in the form state
      try {
        setLoading(true);
        const body = { ...data, phone_number: phoneNumber ? phoneNumber : "" };
        const response = await PATCH(bartenders + "/" + id, body, refreshToken);
        console.log(response, 'response');
        updateBartenderInfo(body);
        Alert({ message: response?.data?.message });
        setLoading(false);
        setChanged(false);
        dispatch(formStateChange(false));

        reset({
          first_name: data.first_name,
          last_name: data.last_name,
          email: data.email,
        });
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    // reset form state
    dispatch(formStateChange(false));
    reset({
      first_name,
      last_name,
      email,
    });
    setPhoneNumber(phone_number);
  }, [email]);

  useEffect(() => {
    if (isDirty || changed) {
      dispatch(formStateChange(true));
    }
  }, [isDirty, changed]);

  const handleProfileImg = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      // Check file size
      const MAX_FILE_SIZE_BYTES = 3 * 1024 * 1024; // 3 MB in bytes
      if (file.size > MAX_FILE_SIZE_BYTES) {
        // Display an error message
        Alert({
          message: "File size exceeds the maximum limit of 3 MB.",
          type: "error",
        });
        // Clear the selected file from the input element
        e.target.value = "";
        return;
      }

      if (!file.type.startsWith("image/")) {
        // Display an error message
        Alert({ message: "Please select an image file.", type: "error" });
        // Clear the selected file from the input element
        e.target.value = "";
        return;
      }

      const fileWithTimestamp = addTimestampToFile(file);
      updateAvatar(fileWithTimestamp);
      setProfile(fileWithTimestamp); // Set profile image with timestamped file name
    }
  };

  const updateAvatar = async (file: File) => {
    // update profile image
    try {
      const formData = new FormData();
      formData.append("avatar", file);
      const response = await PATCH_MULTIPART(
        bartenderAvatar + "/" + id,
        formData,
        refreshToken
      );
      Alert({ message: response?.data?.message });
    } catch (error) {
      console.log(error);
    }
  };

  function addTimestampToFile(file: File): File {
    // Add a timestamp to the file name to prevent overwriting of files with the same name
    const timestamp = Date.now(); // Get current timestamp
    const fileName = `${timestamp}_${file.name}`; // Add timestamp to file name
    return new File([file], fileName, { type: file.type }); // Create a new file object with timestamped name
  }

  // model
  const handleModalOkay = () => {
    setModal(false);
  };

  const handleModalCancel = () => {
    dispatch(formStateChange(false));
    setModal(false);
    navigateEdit();
  };

  const tryToNavigate = () => {
    // if there is a change in the state display the modal
    if (isChanged) {
      // setNavigtateTo(path)
      setModal(true);
    } else {
      navigateEdit();
    }
  };

  return (
    <div className="mx-auto bg-white rounded-2xl   p-6 w-full">
      <div className="px-2 lg:block  w-full flex justify-stretch flex-col items-center ">
        <div className="flex items-center justify-between gap-4">
          <p className="text-2xl font-semibold">Personal Information</p>
          {/* <img onClick={tryToNavigate} className="h-4 ml-4 w-auto cursor-pointer" src={iconEdit} /> */}
          {/* <div
            className="h-4 ml-3 w-auto cursor-pointer"
            onClick={tryToNavigate}
          >
            <EditIcon />
          </div> */}
          {!isSuperAdmin && (
            <div
              // onClick={tryToNavigate}
              onClick={openModal}
              className="cursor-pointer flex items-center gap-2 bg-p-gray py-1  px-3 rounded-full text-sm font-semibold"
            >
              <FiEdit2 size={14} />
              Edit
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row justify-between items-center">
        <div className="px-2 lg:w-fit w-full flex relative justify-center flex-col items-center ">
          <img
            className="mt-4 md:w-32 md:h-32 h-24 w-24 object-cover rounded-full   border-2 self-center"
            src={
              profile
                ? URL.createObjectURL(profile)
                : img?.includes("https://")
                ? img
                : defaultuser
            }
          />
          {/* <div className="bg-primary-red absolute rounded-full p-2 bottom-0 md:ml-32 ml-20  cursor-pointer">
            <label className=" cursor-pointer">
              <img
                title="Upload picture"
                className="h-3 w-auto"
                src={iconEdit}
              />
              <input
                id="profile-img"
                accept="image/*"
                onChange={handleProfileImg}
                type="file"
                className="hidden"
              />
            </label>
          </div> */}
        </div>

        <div
          className="  h-full flex flex-col lg:w-9/12 w-full justify-between gap-5"
          // onSubmit={handleSubmit(onSubmit)}
        >
          <div className="">
            <p className="text-xl font-semibold  ">
              {first_name + " " + last_name}
            </p>
          </div>

          <div className=" flex md:flex-row flex-col justify-start md:gap-10">
            <div>
              <p className="font-semibold">Email</p>
              <p className="text-[#8D8D8D]">{email}</p>
            </div>
            <div>
              <p className="font-semibold">Phone</p>
              <p className="text-[#8D8D8D]">
                {phone_number != "" && phone_number ? phone_number : "N/A"}
              </p>
            </div>
          </div>
        </div>
      </div>
      {modal && (
        <ChangesAlert
          isOpen={modal}
          title="Unsaved Changed"
          desc="You have unsaved changes. Are you sure you want to leave?"
          positiveButtonText="No, Stay"
          negativeButtonText="Yes, Leave"
          handleDiscardChanges={handleModalCancel}
          handleSaveChanges={handleModalOkay}
        />
      )}
      {/* edit modal */}
      <FormModal
        modalTitle="Edit Bartender"
        isOpen={isModalOpen}
        width="lg:w-3/6 md:w-5/6 w-full"
        height="overflow-y-auto"
        overflow="overflow-hidden "
        onClose={closeModal}
      >
        <AddBartenderModal
          isEdit={true}
          closeModal={closeModal}
          receivedData={currentBartender}
          rerenderFun={rerenderFun}
        />
      </FormModal>
    </div>
  );
};

export default BartenderPersonalInformation;
